
// import 
import style from './ranking.module.css'

export default function RankingRelatorio({ranking, tipo}){
    return(
        <div className={style.resumoTurma}>
            <h3>Classificação por {tipo}</h3>
            {ranking && ranking.map((item,id)=>
                    <div key={id}>
                        <p>{id + 1}º {item.nome}</p>
                        <p> {item.valor}</p>
                    </div>
                )}
        </div>
    )
}